import axios from 'axios'

const savedVistaActiva = localStorage.getItem('vista-difusion-activa') ?
  JSON.parse(localStorage.getItem('vista-difusion-activa')) : null
const allVistas = {}
if (savedVistaActiva) {
  allVistas[savedVistaActiva.id] = savedVistaActiva
}

export default {
  state: {
    vistaActivaId: savedVistaActiva ? savedVistaActiva.id : null,
    showSideNav: false,
    allVistas: allVistas,
    loadedAllVistas: false,
    publicacionesDisponibles: null,

    //Cosas de productos relacionados a K10 que van a dar F3
    productoToF3: null,
    costoF3: 0,

    patrocinadorK10Data: null,
    vistasDifusionRS: {},
    //{[id]: {id, nombre, username, default_gradient, picture_url, followed?}, ...}

    //Comentarios
    unsavedComentarioData: null,
    errorSavingComment: false,
    replyingToComment: null,
    intrinsicReplyTo: null,
  },
  mutations: {
    SET_VISTA_ACTIVA_ID(state, id) {
      state.vistaActivaId = id
    },
    SET_SHOW_SIDE_NAV(state, bool) {
      state.showSideNav = bool
    },
    SET_ALL_VISTAS(state, obj) {
      state.allVistas = obj
    },
    SET_VISTA_IN_ALL_VISTAS(state, vista) {
      state.allVistas[vista.id] = vista
    },
    SET_LOADED_ALL_VISTAS(state, bool) {
      state.loadedAllVistas = bool
    },
    SET_PUBK10_DISPONIBLES(state, number) {
      state.publicacionesDisponibles = number
    },

    //Cosas de productos relacionados a K10 que van a dar F3
    SET_PRODUCTO_TO_F3(state, orden) {
      state.productoToF3 = orden
    },
    SET_COSTO_F3(state, costo) {
      state.costoF3 = costo
    },

    SET_PATROCINADOR_K10_DATA(state, data) {
      state.patrocinadorK10Data = data
    },
    SET_VISTAS_DIFUSION_RS(state, vistas) {
      state.vistasDifusionRS = vistas
    },
    ADD_VISTAS_DIFUSION_RS(state, newVistas) {
      state.vistasDifusionRS = {...state.vistasDifusionRS, ...newVistas}
    },
    SET_VISTA_IN_VISTAS_DIFUSION_RS(state, vista) {
      state.vistasDifusionRS[vista.id] = {...state.vistasDifusionRS[vista.id], ...vista}
    },

    // Comentarios
    SET_UNSAVED_COMENTARIO_DATA(state, data) {
      state.unsavedComentarioData = data
    },
    SET_ERROR_SAVING_COMMENT(state, bool) {
      state.errorSavingComment = bool
    },
    SET_REPLYING_TO_COMMENT(state, obj) {
      state.replyingToComment = obj
    },
    SET_INTRINSIC_REPLY_TO(state, obj) {
      state.intrinsicReplyTo = obj
    }
  },
  getters: {
    vistaActivaId: state => state.vistaActivaId,
    vistaDifusionActiva: state => state.vistaActivaId ? state.allVistas[state.vistaActivaId] : null,
    showSideNav: state => state.showSideNav,
    allVistas: state => state.allVistas,
    loadedAllVistas: state => state.loadedAllVistas,
    pubK10Disponibles: state => state.publicacionesDisponibles,

    //Cosas de saldo K10
    productoToF3: state => state.productoToF3,
    costoF3: state => state.costoF3,

    patrocinadorK10Data: state => state.patrocinadorK10Data,
    vistasDifusionRS: state => state.vistasDifusionRS,

    // Comentarios
    unsavedComentarioData: state => state.unsavedComentarioData,
    errorSavingComment: state => state.errorSavingComment,
    replyingToComment: state => state.replyingToComment,
    intrinsicReplyTo: state => state.intrinsicReplyTo,
  },
  actions: {
    updateVistaInAllVistas({ state, commit, dispatch }, vista) {
      commit('SET_VISTA_IN_ALL_VISTAS', {...(state.allVistas[vista.id] || {}), ...vista})
      if (vista.id === state.vistaActivaId) {
        dispatch('updateSavedVistaActiva')
      }
    },
    updateVistaActivaId({ commit, dispatch, getters }, id) {
      if (getters.vistaActivaId !== id) {
        commit('SET_VISTAS_DIFUSION_RS', {})
        axios.post(`/api/v2/koinonia10/influencer/set-vista-activa.json`, {
          id: id
        })
      }
      commit('SET_VISTA_ACTIVA_ID', id)
      dispatch('updateSavedVistaActiva')
    },
    localUpdateVistaActivaId({ commit, dispatch, getters }, id) {
      if (getters.vistaActivaId !== id) {
        commit('SET_VISTAS_DIFUSION_RS', {})
      }
      commit('SET_VISTA_ACTIVA_ID', id)
      dispatch('updateSavedVistaActiva')
    },
    updateSavedVistaActiva({ state }) {
      if (state.vistaActivaId && state.allVistas[state.vistaActivaId]) {
        localStorage.setItem('vista-difusion-activa', JSON.stringify(state.allVistas[state.vistaActivaId]))
      } else {
        localStorage.removeItem('vista-difusion-activa')
      }
    },
    async saveComment({ state, commit }) {
      const params = {...state.unsavedComentarioData}
      if (state.unsavedComentarioData.newComment) {
        delete params.id
      }
      delete params.newComment

      await axios.post(`api/v2/koinonia10/influencer/comentario/save.json`,params).
      then(async resp => {
        if (resp.data.ok) {
          const {id, comentario_id, publicacion_id} = state.unsavedComentarioData
          commit('SET_EVENT_BUS', {
            type: 'k10-comentario-saved',
            timestamp: Date.now(),
            data: {newId: resp.data.id, id, comentario_id, publicacion_id}
          })
          commit('SET_ERROR_SAVING_COMMENT', false)
          commit('SET_UNSAVED_COMENTARIO_DATA', null)
          commit('SET_REPLYING_TO_COMMENT', null)
        } else {
          Metro.notify.create(resp.data.error || ' ', 'Error', {cls: "bg-red fg-white"})
          commit('SET_ERROR_SAVING_COMMENT', true)
        }
      }).catch(() => {
        Metro.notify.create('Error', null, {cls: "bg-red fg-white"})
      })
    },
    async getAllVistas({ commit, getters, dispatch }) {
      if (!getters.loadedAllVistas) {
        await axios.get(`/api/v2/koinonia10/influencer/vista-difusion/all.json`).
        then(async resp => {
          dispatch('updateExistingVistasDifusionRs', {
            vistas: Object.values(resp.data.all),
            validAttributes: ['id','nombre','username','default_gradient','picture_url']
          })
          commit('SET_ALL_VISTAS', resp.data.all)
          commit('SET_LOADED_ALL_VISTAS', true)

          let vistaActivaIdOk = false
          if (resp.data.vista_activa_id) {
            commit('SET_VISTA_ACTIVA_ID', resp.data.vista_activa_id)
            vistaActivaIdOk = true
          } else if (getters.vistaActivaId && resp.data.all[getters.vistaActivaId]) {
            await axios.post(`/api/v2/koinonia10/influencer/set-vista-activa.json`, {
              id: getters.vistaActivaId
            }).then(resp => {
              vistaActivaIdOk = !!resp.data.ok
            })
          }

          if (!vistaActivaIdOk && !$.isEmptyObject(resp.data.all)) {
            let id
            for (let key in resp.data.all) {
              id = Number(key)
              break
            }
            await axios.post(`/api/v2/koinonia10/influencer/set-vista-activa.json`, {
              id: id
            }).then(resp => {
              if (resp.data.ok) {
                vistaActivaIdOk = true
                commit('SET_VISTA_ACTIVA_ID', id)
              }
            })
          }

          if (!vistaActivaIdOk) {
            commit('SET_VISTA_ACTIVA_ID', null)
          }

          dispatch('updateSavedVistaActiva')
        }).catch(() => {})
      }
    },
    checkVistasDifusionRs({ getters, commit }, payload) {
      return new Promise(async resolve => {
        const idsToSearch = [...new Set(payload.ids)].filter(id => !getters.vistasDifusionRS[id])

        if (idsToSearch.length > 0) {
          await axios.get(`api/v2/koinonia10/rs/vistas-difusion.json`,{
            params: {
              lista: idsToSearch
            }
          }).then(resp => {
            commit('ADD_VISTAS_DIFUSION_RS', resp.data.vistas_difusion)
          }).catch(() => {})
        }
        resolve()
      })
    },
    updateExistingVistasDifusionRs({ getters, commit }, payload) {
      return new Promise(resolve => {
        payload.vistas.forEach(vista => {
          if (getters.vistasDifusionRS[vista.id]) {
            const updatedInfo = payload.validAttributes.reduce((obj,attr) => {
              obj[attr] = vista[attr]
              return obj
            }, {})
            commit('SET_VISTA_IN_VISTAS_DIFUSION_RS', updatedInfo)
          }
        })
        resolve()
      })
    },
    followVistaDifusion({ dispatch, commit }, payload) {
      axios.post(`api/v2/koinonia10/rs/follow.json`, {
        username: payload.vistaToFollow.username,
        unactive_ids: payload.otherIds
      }).then(response => {
        if (response.data.ok) {
          dispatch('updateExistingVistasDifusionRs', {
            vistas: [{id: payload.vistaToFollow.id, followed: true}],
            validAttributes: ['id','followed']
          })
          commit('SET_EVENT_BUS', {
            type: 'k10-vista-follow',
            timestamp: Date.now(),
            data: {id: payload.vistaToFollow.id, followed: true, newFollowers: response.data.new_followers}
          })
        } else {
          Metro.notify.create('Error', null, {cls: "bg-red fg-white"})
        }
      }).catch(() => {
        Metro.notify.create('Error', null, {cls: "bg-red fg-white"})
      })
    },
    unfollowVistaDifusion({ dispatch, commit }, payload) {
      axios.post(`api/v2/koinonia10/rs/unfollow.json`, {
        username: payload.vistaToUnfollow.username,
        unactive_ids: payload.otherIds
      }).then(response => {
        if (response.data.ok) {
          dispatch('updateExistingVistasDifusionRs', {
            vistas: [{id: payload.vistaToUnfollow.id, followed: false}],
            validAttributes: ['id','followed']
          })
          commit('SET_EVENT_BUS', {
            type: 'k10-vista-follow',
            timestamp: Date.now(),
            data: {id: payload.vistaToUnfollow.id, followed: false, newFollowers: response.data.new_followers}
          })
        } else {
          Metro.notify.create('Error', null, {cls: "bg-red fg-white"})
        }
      }).catch(() => {
        Metro.notify.create('Error', null, {cls: "bg-red fg-white"})
      })
    },
    async refreshState({ commit }) {
      commit('SET_SHOW_SIDE_NAV', false)
      commit('SET_LOADED_ALL_VISTAS', false)
      commit('SET_PUBK10_DISPONIBLES', null)
      commit('SET_PATROCINADOR_K10_DATA', null)
      commit('SET_VISTAS_DIFUSION_RS', {})
      commit('SET_UNSAVED_COMENTARIO_DATA',null)
      commit('SET_ERROR_SAVING_COMMENT', false)
      commit('SET_REPLYING_TO_COMMENT', null)
      commit('SET_INTRINSIC_REPLY_TO', null)
    },
    async logoutActions({ commit, dispatch }) {
      // Lo mismo que en refresh state
      commit('SET_SHOW_SIDE_NAV', false)
      commit('SET_LOADED_ALL_VISTAS', false)
      commit('SET_PUBK10_DISPONIBLES', null)
      commit('SET_PATROCINADOR_K10_DATA', null)
      commit('SET_UNSAVED_COMENTARIO_DATA',null)
      commit('SET_ERROR_SAVING_COMMENT', false)
      commit('SET_REPLYING_TO_COMMENT', null)
      commit('SET_INTRINSIC_REPLY_TO', null)

      await dispatch('localUpdateVistaActivaId',null)
      commit('SET_ALL_VISTAS',{})
    }
  }
}